module.exports = __webpack_public_path__ + "static/media/equalizer.2aa3ace2.svg";